interface SelectOptionLike {
	label: string
	value: string | number
}

interface SelectOptionCategorizedLike {
	selectOptions: SelectOptionLike[]
}

export const mapDateValue = (
	date: string | undefined,
	dateFormat: string,
	parseDate: (date: string, format: string) => string | undefined,
) => {
	const formatted = date ? parseDate(date, dateFormat) : undefined
	return formatted ? [formatted] : undefined
}

export const mapSingleValue = (value: string | number | undefined, options: SelectOptionLike[] | undefined) =>
	value === undefined || value === "" ? undefined : [options?.find((option) => option.value === value)?.label ?? ""]

export const mapArrayValues = (values: string[] | undefined, options: SelectOptionLike[] | undefined) =>
	values?.map((val) => options?.find((option) => option.value === val)?.label ?? "")

export const mapCategorizedArrayValues = (
	values: string[] | undefined,
	options: SelectOptionCategorizedLike[] | undefined,
) => {
	const flatFilter = options?.flatMap((option) => option.selectOptions)
	return values?.map((val) => flatFilter?.find((option) => option.value === val)?.label ?? "")
}
